import {useSelector} from 'react-redux'
import {getIsIsraeliResident} from 'modules/meta/selectors'
import {getHotelHasIsraeliVat} from 'modules/searchApi/selectors'

/**
 * Israeli VAT is charged only to Israeli residents, so residents see it
 * included in the price ("incl. taxes & fees") while everyone else sees
 * "Additional charges may apply".
 */
export const useIsraeliVatEligibility = (hotelId: string) => {
  const isPropertyEligible = useSelector(state =>
    getHotelHasIsraeliVat(state, hotelId)
  )
  const isIsraeliResident = useSelector(getIsIsraeliResident)

  return {
    isPropertyEligible,
    isLocalVatIncluded: isPropertyEligible && isIsraeliResident,
    hasAdditionalCharges: isPropertyEligible && !isIsraeliResident
  }
}
